// extracted by mini-css-extract-plugin
module.exports = {"example":"RootLayout_example__JI93W","Main":"RootLayout_Main____8ES"};